'use strict';
import * as $j_app$002eapi$002e$002dGeneral$002dPractice$002dApp$002dUpdate from "./app.api.-General-Practice-App-Update.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_GeneralPracticeAppUpdate$InMaintenance(data) {
  this.Lapp_api_GeneralPracticeAppUpdate$InMaintenance__f_data = null;
  this.Lapp_api_GeneralPracticeAppUpdate$InMaintenance__f_data = data;
}
export { $c_Lapp_api_GeneralPracticeAppUpdate$InMaintenance as $c_Lapp_api_GeneralPracticeAppUpdate$InMaintenance };
$c_Lapp_api_GeneralPracticeAppUpdate$InMaintenance.prototype = new $j_app$002eapi$002e$002dGeneral$002dPractice$002dApp$002dUpdate.$h_Lapp_api_GeneralPracticeAppUpdate();
$c_Lapp_api_GeneralPracticeAppUpdate$InMaintenance.prototype.constructor = $c_Lapp_api_GeneralPracticeAppUpdate$InMaintenance;
/** @constructor */
function $h_Lapp_api_GeneralPracticeAppUpdate$InMaintenance() {
}
export { $h_Lapp_api_GeneralPracticeAppUpdate$InMaintenance as $h_Lapp_api_GeneralPracticeAppUpdate$InMaintenance };
$h_Lapp_api_GeneralPracticeAppUpdate$InMaintenance.prototype = $c_Lapp_api_GeneralPracticeAppUpdate$InMaintenance.prototype;
$c_Lapp_api_GeneralPracticeAppUpdate$InMaintenance.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 144150076, true);
});
$c_Lapp_api_GeneralPracticeAppUpdate$InMaintenance.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_api_GeneralPracticeAppUpdate$InMaintenance)) {
    var x = this.Lapp_api_GeneralPracticeAppUpdate$InMaintenance__f_data;
    var x$2 = x$0.Lapp_api_GeneralPracticeAppUpdate$InMaintenance__f_data;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lapp_api_GeneralPracticeAppUpdate$InMaintenance.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_api_GeneralPracticeAppUpdate$InMaintenance.prototype.productArity__I = (function() {
  return 1;
});
$c_Lapp_api_GeneralPracticeAppUpdate$InMaintenance.prototype.productPrefix__T = (function() {
  return "InMaintenance";
});
$c_Lapp_api_GeneralPracticeAppUpdate$InMaintenance.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_api_GeneralPracticeAppUpdate$InMaintenance__f_data;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_api_GeneralPracticeAppUpdate$InMaintenance.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "data";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_api_GeneralPracticeAppUpdate$InMaintenance.prototype.ordinal__I = (function() {
  return 1;
});
function $isArrayOf_Lapp_api_GeneralPracticeAppUpdate$InMaintenance(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_api_GeneralPracticeAppUpdate$InMaintenance)));
}
export { $isArrayOf_Lapp_api_GeneralPracticeAppUpdate$InMaintenance as $isArrayOf_Lapp_api_GeneralPracticeAppUpdate$InMaintenance };
var $d_Lapp_api_GeneralPracticeAppUpdate$InMaintenance = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_GeneralPracticeAppUpdate$InMaintenance, "app.api.GeneralPracticeAppUpdate$InMaintenance", ({
  Lapp_api_GeneralPracticeAppUpdate$InMaintenance: 1,
  Lapp_api_GeneralPracticeAppUpdate: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
export { $d_Lapp_api_GeneralPracticeAppUpdate$InMaintenance as $d_Lapp_api_GeneralPracticeAppUpdate$InMaintenance };
//# sourceMappingURL=app.api.-General-Practice-App-Update$-In-Maintenance.js.map
